import React from 'react';
import { TODO_TASK_ACTIONS } from '@/constants';
import { TodoBucketItem } from '../types';
import TodoItemAvailability from './Todo.item.availability';
import ConfirmEventAttendanceItem from './Todo.item.confirmEventAttendance';

type TodoItemProps = {
  item: TodoBucketItem;
};

const TodoItem: React.FC<TodoItemProps> = ({ item }) => {
  if (item.type === 'summary') {
    return <TodoItemAvailability summary={item.summary} />;
  }
  if (item.type === 'task' && item.task.action === TODO_TASK_ACTIONS.CONFIRM_EVENT_ATTENDANCE) {
    return <ConfirmEventAttendanceItem task={item.task} />;
  }
  return null;
};

export default TodoItem;
